/** React Router state for resuming a Scenario Practice session from History. */
export type ScenarioResumeNavigateState = {
  resumeSessionId: string;
};

export function isScenarioResumeState(value: unknown): value is ScenarioResumeNavigateState {
  return (
    typeof value === "object" &&
    value !== null &&
    typeof (value as ScenarioResumeNavigateState).resumeSessionId === "string"
  );
}
